import { CustomPDFReportDesignation } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-designation.enum';
export const NAMING_CONVENTION_PREFERENCE_KEY = 'customPDFReports_namingConvention';
export const DESIGNATION_TYPE_NAME_MAPPING = {
    [CustomPDFReportDesignation.DRAFT]: 'Draft',
    [CustomPDFReportDesignation.DELIVERABLE]: 'Deliverable',
};
// Validator parameters
export const REPORT_CUSTOM_FIELD_MAX_LENGTH = 255; // Update to match backend limitation
export const REPORT_CONTACT_EMAIL_MAX_LENGTH = 255;
export const REPORT_CONTACT_PHONE_MAX_LENGTH = 20;
export const REPORT_CONTACT_URL_MAX_LENGTH = 150;
export const REPORT_PREPARED_FOR_MAX_LENGTH = 50;
export const REPORT_PREPARED_BY_MAX_LENGTH = 50;
export const REPORT_ORGANIZATION_MAX_LENGTH = 50;
export const REPORT_TITLE_MAX_LENGTH = 150;
// Modal field names
export const PREPARED_BY_FIELD_NAME = 'reportPreparedBy';
export const MULTI_SECURITY_COMPARISON_ADDITIONAL_SECURITY_COUNT_MAX = 5;
export const MULTI_SECURITY_COMPARISON_ADDITIONAL_SECURITY_COUNT_MIN = 2;
import { FolderableAppType } from 'FoldersApp/enums/folderable-app-type.enum';
export const GENERATE_REPORT_MODAL_FOLDERABLE_APP_CONFIG = {
    appName: 'GeneratePDFReportModal',
    folderableAppType: FolderableAppType.MODAL,
    itemNamePlural: 'Report Templates',
};
